"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  active: false,
  disabled: false,
  ref: null,
  files: [],
  accepted: [],
  rejected: [],
  open: function open() {},
  onClick: function onClick() {},
  onDragStart: function onDragStart() {},
  onDragEnter: function onDragEnter() {},
  onDragOver: function onDragOver() {},
  onDragLeave: function onDragLeave() {},
  onDrop: function onDrop() {}
});

exports["default"] = _default;